import { useTranslation } from 'react-i18next';
import * as v from 'valibot';
const SECURITY_URL_REGEX = /^(https:\/\/)([a-zA-Z0-9-]+\.)+[a-zA-Z]{2,}(:[0-9]{1,5})?(\/[^\s]*)?$/;
const MIN_VALID_DATE = new Date(new Date().setHours(0, 0, 0, 0));
const isValidInterval = (startTime, endTime) => {
    const arbitraryDate = '01/01/2000';
    const startDateTime = new Date(`${arbitraryDate} ${startTime}`);
    const endDateTime = new Date(`${arbitraryDate} ${endTime}`);
    return endDateTime.getTime() > startDateTime.getTime();
};
export function useMentorshipSchema() {
    const { t } = useTranslation();
    const schema = v.object({
        cover: v.union([
            v.object({
                id: v.string(),
                name: v.string(),
                url: v.string()
            }),
            v.null()
        ]),
        name: v.pipe(v.string(), v.nonEmpty(t('mentorship.form.name.errors.required'))),
        link: v.pipe(v.string(), v.nonEmpty(t('mentorship.form.link.errors.required')), v.startsWith('https://', t('mentorship.form.link.errors.must_start_with')), v.regex(SECURITY_URL_REGEX, t('mentorship.form.link.errors.invalid'))),
        date: v.pipe(v.date(), v.minValue(MIN_VALID_DATE, t('mentorship.form.date.errors.invalid'))),
        startTime: v.pipe(v.string(), v.nonEmpty(t('mentorship.form.time.errors.required')), v.isoTime(t('mentorship.form.time.errors.invalid'))),
        endTime: v.pipe(v.string(), v.nonEmpty(t('mentorship.form.time.errors.required')), v.isoTime(t('mentorship.form.time.errors.invalid'))),
        classes: v.pipe(v.array(v.string()), v.minLength(1, t('mentorship.form.name.errors.required')))
    });
    const timeSchema = v.pipe(v.pick(schema, ['startTime', 'endTime']), v.forward(v.check(({ startTime, endTime }) => isValidInterval(startTime, endTime), t('mentorship.form.time.errors.invalid_interval')), ['endTime']));
    return v.intersect([schema, timeSchema]);
}
